import BaseModel from "./_mbase.js";

class FieldValidationModel extends BaseModel {

    rule = '';
    format = '';
    message =  '';

    constructor() {
        super();
    }

    fromJSON(data) {
        super.fromJSON(data);
        this.rule = data['rule'];
        this.format = data['format'];
        this.message = data['message'];
        return this;
    }

    toJSON() {

    }
}

export default FieldValidationModel;